import { render, staticRenderFns } from "./edition.vue?vue&type=template&id=30c3a25b&"
import script from "./edition.vue?vue&type=script&lang=js&"
export * from "./edition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c3a25b')) {
      api.createRecord('30c3a25b', component.options)
    } else {
      api.reload('30c3a25b', component.options)
    }
    module.hot.accept("./edition.vue?vue&type=template&id=30c3a25b&", function () {
      api.rerender('30c3a25b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/editionInstructions/edition.vue"
export default component.exports